import { Component, OnInit } from '@angular/core';
import { ANDROID_APP_LINK, IOS_APP_LINK } from 'src/app/constants/emailAndLinks';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-cariq-applications',
  templateUrl: './cariq-applications.component.html',
  styleUrls: ['./cariq-applications.component.scss'],
  standalone: false
})
export class CariqApplicationsComponent implements OnInit {

  ANDROID_APP_LINK = ANDROID_APP_LINK;
  IOS_APP_LINK = IOS_APP_LINK
  Images = IMAGES;
  constructor() { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

}
